import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Fade from 'react-reveal/Fade';

import { useFormik } from 'formik';
import { string, object } from 'yup';

import { authActions } from '../actions';

import HeaderAccount from '../components/HeaderAccount/HeaderAccount';

import '../App.scss';
import '../Styles/Account/Account.scss';
import '../Styles/Forms.scss';

const Login = () => {
  const [error, setError] = useState();

  const dispatch = useDispatch();
  const isAuthenticating = useSelector(state => state.auth.authenticating);
  const message = useSelector(state => state.auth.message);
  const membershipExpired = useSelector(state => state.auth.membershipExpired);

  useEffect(() => {
    if (!!message) {
      setError(message);
    }
  }, [message]);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: ""
    },
    validationSchema: object({
      username: string()
        .required("Email address is required")
        .email("Email address is invalid"),
      password: string()
        .required("Password is required")
    }),
    onSubmit: values => {
      dispatch(authActions.login(values.username, values.password));
    }
  });

  useEffect(() => {
    dispatch(authActions.logout());
  }, [dispatch]);

  if (membershipExpired) {
    return <Redirect to="/expired-membership" />
  }

  return (
    <Fade duration={1000} delay={300}>
      <div className="l_account account--credentials">

        <HeaderAccount />

        <div className="l_account-left">
          <div className="account__header">
            <Fade delay={400} duration={600} distance={'30px'} bottom >
              <div>
                <h1 className="account__title h1">
                  Welcome back to your virtual learning dashboard
                </h1>
                <p>
                  Login to complete your course preparation, begin your course and access the continuous learning material.
                </p>
              </div>
            </Fade>
          </div>
          <div className="col-height"></div>
        </div>
        <div className="l_account-right">
          <Fade delay={700} duration={600} distance={'30px'} bottom>
            <form className="form" onSubmit={formik.handleSubmit}>

              <h2 className="h3">
                Login
              </h2>

              <div className="form__group">
                <label className="form__label" htmlFor="email">Email Address</label>
                {/* Add class 'is-error' to input when in error state */}
                <input
                  id="email"
                  className={`form__control
                    ${formik.touched.username && formik.errors.username ? "is-error" : ""}`}
                  name="username"
                  type="text"
                  autoComplete="off"
                  value={formik.values.username}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
                {
                  formik.touched.username && formik.errors.username &&
                  <div className="form__group__error">
                    {formik.errors.username}
                  </div>
                }
              </div>

              <div className="form__group">
                <label className="form__label" htmlFor="password">Password</label>
                {/* Add class 'is-error' to input when in error state */}
                <input
                  id="password"
                  className={`form__control
                    ${formik.touched.password && formik.errors.password ? "is-error" : ""}`}
                  name="password"
                  type="password"
                  value={formik.values.password}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
                {
                  formik.touched.password && formik.errors.password &&
                  <div className="form__group__error">
                    {formik.errors.password}
                  </div>
                }
              </div>

              <div className="forgot-password-cta">
                <Link to="/forgot-password">Forgot password?</Link>
              </div>

              {/* Add class 'is-loading' to button when submitting */}
              <button
                type="submit"
                className={`button button--primary-arrow ${isAuthenticating ? "is-loading" : ""}`}
              >
                <span className="button__text">Login</span>
                <span className="button__icon">
                  <svg className="icon-arrow-solid">
                    <use xlinkHref="#icon-arrow-solid">
                    </use>
                  </svg>
                </span>
                <span className="button__loader">
                </span>
              </button>
              <div className="form__error-container">
                {
                  !!error &&
                  <span className="form__error">
                    {error}
                  </span>
                }
              </div>
            </form>
          </Fade>

          <div className="col-height"></div>
        </div>
      </div >
    </Fade>

  );
}

export default Login;
